import { render, staticRenderFns } from "./PopupCollaboration.vue?vue&type=template&id=2f71d40e"
import script from "./PopupCollaboration.vue?vue&type=script&lang=js"
export * from "./PopupCollaboration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports